import Vue from 'vue';
import store from '@/store';
import AdvertiserProxy from "../../../proxies/AdvertiserProxy";
import * as types from './mutation-types';


/**
 * 광고주 (광고)
 * @param commit
 * @param param
 */
/*export const getAdvertiserMediaList = ({ commit }, searchParam) => {
  new AdvertiserProxy({mediaType : searchParam.searchMediaType})
    .getAdvertiserMediaList(searchParam.searchCompanySeq)
    .then((response) => {
      commit(types.MEDIAS, response);
    });
};*/

/**
 * 광고주 (광고) 초기화
 * @param commit
 * @param param
 */
export const initAdvertiserMediaList = ({ commit }) => {
  let response = {medias: []};
  commit(types.MEDIAS, response);
};

/**
 * 광고 선택항목 저장
 * @param commit
 * @param multipleSelection
 */
export const setMultipleSelection = ({ commit }, params) => {
  commit(types.MULTI_SELECT, params);
};

/**
 * 광고 선택항목 초기화
 * @param commit
 */
export const initMultipleSelection = ({ commit }) => {
  commit(types.INIT_MULTI_SELECT);
};


export default {
  // getAdvertiserMediaList,
  initAdvertiserMediaList,
  setMultipleSelection,
  initMultipleSelection,
};
